<template>
  <!-- main content -->
  <div>
    <!-- {{ filters }}<br />{{ rx }} -->

    <v-skeleton-loader
      v-show="loading"
      :type="$vuetify.breakpoint.smAndUp ? 'paragraph,table' : 'card card'"
      class="my-10"
    ></v-skeleton-loader>
    <div class="clSearchResults mx-0 mx-sm-2" v-if="searchResults">
      <!-- ----- search results by lens ------- -->
      <div v-if="searchResults" v-show="!loading">
        <soft-result-display :lensObj="searchResults" :nameSearch="term" />
      </div>
    </div>
    <!-- end search results div -->
  </div>
</template>

<script>
import AllClDataMixin from "@/assets/js/cls/AllClDataMixin";
import ClCompanyMixin from "@/assets/js/cls/ClCompanyMixin";
import ApiServices from "@/services/ApiServices";

export default {
  name: "SoftHome",
  title: "EyeDock Soft Lens Searches",
  mixins: [AllClDataMixin, ClCompanyMixin],
  components: {
    SoftResultDisplay: () => import("@/components/clStuff/SoftResultDisplay"),
  },
  props: {
    // filters: null,
  },
  data: () => ({
    type: null,
    company: null,
    hideDiscontinued: true,
    loading: false,
    searchResults: null,
    powerSearchResults: null,
    term: null,
  }),

  computed: {
    pageTitle: function () {
      let rtn = "";
      if (this.type) rtn = this.deSlug(this.type);
      if (this.company) rtn = this.deSlug(this.company);
      if (this.term) rtn = this.term;
      return rtn;
    },
  },
  methods: {
    deSlug(str) {
      var i,
        frags = str.split("_");
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    },
    doSearch() {
      // console.log("Do search");
      // this.noRx() ? this.startLensSearch() : this.startPowerSearch();
      this.startLensSearch();
    },
    paramString() {
      let paramString = "";
      if (this.type) paramString = `type_tag=${this.type.toUpperCase()}`;
      if (this.company) paramString = this.getCompanyParamString(this.company); // from ClCompanyMixin
      if (this.term) paramString = "term=" + this.term; // assume already uriencoded...
      // console.log(paramString);
      return paramString;
    },
    startLensSearch() {
      // console.log("startLensSearch");
      if (this.searchResults && this.searchResults.length > 0) return;

      this.powerSearchResults = null;
      this.loading = true;

      let api = this.term ? "lensSearchAPI" : "initialLensDataAPI";

      ApiServices[api](this.paramString())
        .then((response) => {
          this.searchResults = response.data;
          if (response.data?.lenses && response.data.lenses.length == 1)
            this.goToLens(response.data.lenses[0]);

          //this.companiesLoaded = this.selectedCompanyIds;
          this.loading = false;
          this.$emit("isPowerSearch", false);
        })
        .catch((e) => {
          this.loading = false;
          console.log(e); // todo - display it
        });
    },
    goToLens(lensObj) {
      console.log("go to", lensObj);
      let slug = lensObj.slug;
      if (slug) this.$router.push({ path: "/cls/details/" + slug });
    },
  },

  watch: {},
  created() {},
  mounted: function () {
    if (this.$route.params.type) {
      // console.log("type", this.$route.params.type);
      this.type = this.$route.params.type;
    } else if (this.$route.params.company) {
      // console.log("company", this.$route.params.company);
      this.company = this.$route.params.company;
    } else if (this.$route.params.term) {
      // console.log("term", this.$route.params.term);
      this.term = this.$route.params.term;
    } else if (this.$route.query.term) {
      // console.log("term", this.$route.query.term);
      this.term = this.$route.query.term;
    } else if (this.$route.query.q) {
      // console.log("term", this.$route.query.term);
      this.term = this.$route.query.q;
    } else {
      // console.log("no type or company");
      this.type = "sphere";
    }
    this.doSearch();
  },
  metaInfo() {
    return {
      title: "EyeDock/CLs | " + this.pageTitle,
    };
  },
};
</script>

<style scoped>
.linkIconContainer {
  flex: 0 0 30px;
}

.custom-text-field.v-text-field.v-text-field--enclosed .v-input__slot {
  padding: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.5s;
}

.clSearchResults {
  /* max-width: 1000px;  */
  margin: auto;
  /* width: 850px;
  max-width: 95vw; */
}

/* .filterInputDiv {
  width: 200px;
} */
.sideBar {
  max-width: 250px;
}
</style>
